'use strict';

function convertOffsetToTimes(offset, duration) {
    return offset.map((o) => o * duration);
}

exports.convertOffsetToTimes = convertOffsetToTimes;
//# sourceMappingURL=time.cjs.map
